/*
 * ATTENTION:
 * JavaScript engines store objects compactly when all their keys are added in one go. Deleting keys from an
 * object makes the engine switch it to a slower storage that needs several times as much memory. Therefore this
 * copies only the kept keys instead of copying everything and deleting the omitted keys afterwards.
 * This matters for the content service, which creates objects with over 100 keys for every bike variant.
 */
export default <T extends object, K extends string>(propsToOmit: readonly K[] | ReadonlySet<K>, obj: T): Omit<T, K> => {
  // Callers that omit the same keys from many objects pass a Set, so it is not created again for every object
  const keysToOmit: ReadonlySet<string> = propsToOmit instanceof Set ? propsToOmit : new Set(propsToOmit);
  const shallowCopy: Record<string, unknown> = {};

  for (const key in obj) {
    if (Object.hasOwn(obj, key) && !keysToOmit.has(key)) {
      shallowCopy[key] = obj[key];
    }
  }

  return shallowCopy as Omit<T, K>;
};
